import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DoneIcon from '@mui/icons-material/Done';
import GradingIcon from '@mui/icons-material/Grading';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import ButtonGroup from '@mui/material/ButtonGroup';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';
import useAxiosProtect from '../../../hooks/useAxiosProtect';
import useAuth from '../../../hooks/useAuth';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';

const AddTasksModal = props => {
    const [page, setPage] = useState(1);
    //page 1
    const [frequency, setFrequency] = useState('once');  
    const [interval, setInterval] = useState(1);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
    const [eventDate, setEventDate] = useState(dayjs(new Date().toLocaleString('sv-SE', { timeZoneName: 'short' }).slice(0, 16).replace(' ', 'T')));
    const [dateErr, setDateErr] = useState('');
    const [title, setTitle] = useState('');
    const [titleErr, setTitleErr] = useState('');
    const [category, setCategory] = useState('task');
    const [customCategory, setCustomCategory] = useState('');
    const [customCategoryErr, setCustomCategoryErr] = useState('');
    const [status, setStatus] = useState('in progress');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('');
    const maxDescLength = 128;
    const maxTitleLength = 64;
    const maxCategoryLength = 64;

    // page 2
    const {auth, persist} = useAuth();
    const axiosProtect = useAxiosProtect();

    const [opps, setOpps] = useState([]);
    const [selectedOpp, setSelectedOpp] = useState(null);
    const [isOpp, setIsOpp] = useState(false);
    const [oppErr, setOppErr] = useState('');

    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] =  useState(null);
    const [userErr, setUserErr] = useState('');

    var init = useRef(true);
    var submitted = useRef(false);

    useEffect(() => {
        if(!init.current || page !== 2) return;
        init.current = false;

        let queryID = window.location.href.split('/').slice(-1)[0];

        let userQueryString = `?role=${auth.role}&org_id=${auth.org_id}&${props.oppView ? 'opp_id' : 'site_id'}=${queryID}`;
        axiosProtect.get(`/auth/query/get-users-for-task-assignment${userQueryString}`).then(response => {
            setUsers(response.data.users);
        }).catch(err => {
            console.log(err)
        });

        if(!props.oppView){
            axiosProtect.get(`/opp/opportunities/site-opps?siteID=${queryID}`).then(response => {
                setOpps(response.data.opps);
            }).catch(err => {});
        }
    }, [page]);

    const validateFirstForm = () => {
        let isValid = true;
        let now = new Date();
        let evDate = new Date(formatTimestamp(new Date(eventDate)) + ' UTC');

        if(title.trim() === ''){
            setTitleErr('Required');
            isValid = false;
        }else setTitleErr('');

        if(category === 'custom' && customCategory === ''){
            setCustomCategoryErr('Required');
            isValid = false;
        }else setCustomCategoryErr('');

        if((now.getTime() + 60 * 1000) >= evDate.getTime()){
            setDateErr('Deadline must be in the future');
            isValid = false;
        }else setDateErr('');

        return isValid;
    }

    const validateSecondForm = () => {
        let isValid = true;

        if(isOpp && selectedOpp == null){
            setOppErr('Required');
            isValid = false;
        }else setOppErr('');

        if(selectedUser == null){
            setUserErr('Required');
            isValid = false;
        }else setUserErr('');

        return isValid;
    }

    const formatTimestamp = date => {
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}000`;
    }

    const incrementPage = e => {
        e.preventDefault();

        if(page === 1 && validateFirstForm()){
            setPage(2);
        }else if(page === 2 && validateSecondForm()){
            setPage(3);
        }else if(page === 3){
            submitEvent();
        }
    }

    const decrementPage = e => {
        e.preventDefault();
        setPage(page - 1);
    }

    const submitEvent = () => {
        submitted.current = true;

        let payload = {
            deadline: formatTimestamp(eventDate['$d']),
            title: title.trim(),
            category,
            customCategory,
            description: description.trim(),
            creatorUID: auth?.id,
            status: status,
            priority: priority === '' ? null : priority.toLowerCase(),
            manager_uid: selectedUser._id,
            manager_name: `${selectedUser.first_name} ${selectedUser.last_name}`,
            manager_email: selectedUser.email,
            frequency,
            interval
        };

        if(props.oppView){
            payload.siteID = null;
            payload.oppID = parseInt(window.location.href.split('/').slice(-1)[0]);
        }else{
            payload.siteID = parseInt(window.location.href.split('/').slice(-1)[0]);
            payload.oppID = isOpp ? selectedOpp.id : null;
        }

        axiosProtect.post('/t/tasks', payload).then(res => {
            props.addTask(res.data.newTask);
            submitted.current = false;

        }).catch(err => {
            props.setTasksModalOpen(false);
            submitted.current = true;
        });
    }

    const generateFrequencyString = () => {
        let suffix = interval === 1 ? '' : 's';

        if(frequency === 'daily') return `day${suffix}`;
        else if(frequency === 'weekly') return `week${suffix}`;
        else if(frequency === 'monthly') return `month${suffix}`;
        else if(frequency === 'yearly') return `year${suffix}`;
    }

    const getMaxInterval = () => {
        if(frequency === 'daily') return 6;
        else if(frequency === 'weekly') return 3;
        else if(frequency === 'monthly') return 11;
        else if(frequency === 'yearly') return 10;
    }

    return(
        <Modal
            show={props.tasksModalOpen}
            onHide={() => props.setTasksModalOpen(false)}
            backdrop="static"
            centered
        >
            <Modal.Header closeButton style={{backgroundColor: props.modalLoading ? 'rgba(0,0,0,0.125)' : 'inherit'}}>
                {page === 3 ? 'Review details' : 'Create task'}
            </Modal.Header>

            {props.modalLoading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1040
                }}>
                    <CircularProgress />
                </div>
            )}

            <Modal.Body style={{overflow:'hidden', backgroundColor: props.modalLoading ? 'rgba(0,0,0,0.125)' : 'inherit'}}>
                {
                    page === 1 && 
                    <>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Frequency</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={frequency}
                            label="Frequency"
                            onChange={e => {
                                setInterval(1);
                                setFrequency(e.target.value);
                            }}
                        >
                            <MenuItem value='once'>Once</MenuItem>
                            <MenuItem value='daily'>Daily</MenuItem>
                            <MenuItem value='weekly'>Weekly</MenuItem>
                            <MenuItem value='monthly'>Monthly</MenuItem>
                            <MenuItem value='yearly'>Yearly</MenuItem>
                        </Select>
                    </FormControl>

                    {
                        (frequency !== 'once' && frequency !== 'yearly') && 
                            <>
                            <br/>
                            <br/>

                            <ButtonGroup size='small'aria-label="Medium-sized button group">
                                <p style={{margin:'0.5rem 1vh 0 1vh', height:'100%'}}>Recurring every</p>

                                <IconButton key="one" style={{
                                        height:'2rem', width:'2rem'
                                    }} onClick={() => {
                                    if(interval === 1) return;
                                        setInterval(interval - 1);
                                    }} disabled={interval <= 1}
                                >
                                -
                                </IconButton>

                                <p style={{margin:'0.5rem 1vh 0 1vh', height:'100%'}}>{interval}</p>

                                <IconButton key="one" style={{height:'2rem', width:'2rem'}} onClick={() => {
                                        setInterval(interval + 1);
                                    }} disabled={interval >= getMaxInterval()}
                                >
                                +
                                </IconButton>

                                <p style={{margin:'0.5rem 1vh 0 1vh', height:'100%'}}>
                                    {
                                        generateFrequencyString()
                                    }
                                </p>
                            </ButtonGroup>
                            </>
                    }

                    <br/>
                    <br/>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
                            <DateTimePicker
                                label="Task due"
                                value={eventDate}
                                onChange={newDate => setEventDate(newDate)}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    {dateErr !== '' && <><small style={{color:'red'}}>{dateErr}</small><br/></>}

                    <br/>

                    <TextField fullWidth label='Title' value={title} onChange={e => {if(e.target.value.length <= maxTitleLength) setTitle(e.target.value)}} error={titleErr !== ''} 
                    helperText={titleErr === '' ? `${maxTitleLength - title.length} character${maxTitleLength - title.length === 1 ? '' : 's'} left` : titleErr}/>

                    <br/>
                    <br/>

                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Category</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={category}
                            label="Category"
                            onChange={e => {
                                if(e.target.value !== category){
                                    setCustomCategory('');
                                    setCustomCategoryErr('');
                                }
                                setCategory(e.target.value);
                            }}
                        >
                            <MenuItem value='task'>Maintenance task</MenuItem>
                            <MenuItem value='deadline'>Production deadline</MenuItem>
                            <MenuItem value='custom'>Custom</MenuItem>
                        </Select>
                    </FormControl>
                    
                    {
                        category === 'custom' &&
                        <>
                        <br/>
                        <br/>
                        <TextField fullWidth label='Custom task' value={customCategory} onChange={e => {if(e.target.value.length <= maxCategoryLength) setCustomCategory(e.target.value)}} error={customCategoryErr !== ''} 
                        helperText={customCategoryErr === '' ? `${maxCategoryLength - customCategory.length} character${maxCategoryLength - customCategory.length === 1 ? '' : 's'} left` : customCategoryErr}/>
                        </>
                    }

                    <br/>
                    <br/>

                    {/* <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={status}
                            label="Status"
                            onChange={e => setStatus(e.target.value)}
                        >
                            <MenuItem value='in progress'>In progress</MenuItem>
                            <MenuItem value='complete'>Complete</MenuItem>
                            <MenuItem value='overdue'>Overdue</MenuItem>
                            <MenuItem value='on hold'>On hold</MenuItem>
                        </Select>
                    </FormControl>

                    <br/>
                    <br/> */}

                    <TextField 
                        fullWidth placeholder='Description (optional)' value={description} onChange={e => {if(e.target.value.length <=  maxDescLength) setDescription(e.target.value)}} 
                        multiline rows={2} helperText={`${maxDescLength - description.length} character${maxDescLength - description.length === 1 ? '' : 's'} left`}
                    />
                    </>
                }

                {
                    page === 2 &&
                    <Slide direction="left" in={page === 2} mountOnEnter unmountOnExit>
                        <div>                    
                        <Autocomplete
                            id="tk-user-autocomplete"
                            fullWidth
                            options={users.sort((a, b) => -b.first_name.localeCompare(a.first_name))}
                            groupBy={user => user.first_name.substring(0,1)}
                            autoHighlight
                            value={selectedUser}
                            onChange={(_, option) => setSelectedUser(option)}
                            getOptionLabel={(option) => option._id === auth.id ? 'You' : `${option.first_name} ${option.last_name} (${option.email})`}
                            renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                <Box
                                    key={key}
                                    component="li"
                                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                    {...optionProps}
                                >
                                    {option._id === auth.id ? 'You' : `${option.first_name} ${option.last_name} (${option.email})`}
                                </Box>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Member assigned to task"
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                />
                            )}
                        />
                        {userErr !== '' && <small style={{color:'red'}}>{userErr}</small>}

                        <br/>

                        {
                            !props.oppView &&
                            <>
                            <FormControlLabel control={<Checkbox checked={isOpp} onClick={() => {
                                let isOppCopy = !isOpp;
                                if(isOppCopy) setSelectedOpp(null);
                                setIsOpp(isOppCopy);
                            }}/>} label="This task is part of a conservation opportunity" />

                            {isOpp && 
                                <>
                                <br/>
                                <br/>
                                <Autocomplete
                                    id="opp-autocomplete"
                                    fullWidth
                                    options={opps}
                                    autoHighlight
                                    value={selectedOpp}
                                    onChange={(_, option) => setSelectedOpp(option)}
                                    getOptionLabel={(option) => option.title}
                                    renderOption={(props, option) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                        <Box
                                            key={key}
                                            component="li"
                                            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                            {...optionProps}
                                        >
                                            {option.title}
                                        </Box>
                                        );
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select opportunity"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password', // disable autocomplete and autofill
                                            }}
                                        />
                                    )}
                                />
                                </>
                            }
                            {oppErr !== '' && <small style={{color:'red'}}>{oppErr}</small>}
                            </>
                        }
                    </div>
                    </Slide>
                }

                {
                    page === 3 &&
                    <Slide direction="left" in={page === 3} mountOnEnter unmountOnExit>
                        <div>
                            <Typography variant='subtitle1'><strong>{title}</strong></Typography>
                            <Typography variant='subtitle2' gutterBottom>{description}</Typography>
                            <Typography variant='subtitle1' gutterBottom={frequency === 'once'}>Due by {props.formatDate(eventDate['$d'])}</Typography>
                            {frequency !== 'once' && <Typography variant='subtitle1' gutterBottom>Task will recur every{interval === 1 ? ' ' : ` ${interval} `}{generateFrequencyString()}</Typography>}
                            <Typography variant='subtitle1' gutterBottom>Member responsible: {selectedUser.first_name} {selectedUser.last_name}</Typography>
                            {selectedOpp && <Typography variant='subtitle1' gutterBottom>This task part of conservation opportunity "{selectedOpp.title}"</Typography>}
                            {priority !== '' && <Typography variant='subtitle1' color={priority === 'Low' ? 'rgb(8,114,182)' : 'rgb(213,43,0)'}>This task is marked as <strong>{priority.toUpperCase()}</strong> priority</Typography>}
                            </div>
                    </Slide>
                }
            </Modal.Body>

            <Modal.Footer style={{backgroundColor: props.modalLoading ? 'rgba(0,0,0,0.125)' : 'inherit'}}>
                <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                    <div style={{flex:'1', textAlign:'left', display:'flex', alignItems:'center', flexWrap:'wrap'}}>
                        <IconButton onClick={() => {
                            setPriority(priority === 'High' ? '' : 'High');
                        }}>
                            <PriorityHighIcon style={{color: priority === 'High' ? 'rgb(213,43,0)' : 'inherit'}}/>
                        </IconButton>
                        <IconButton onClick={() => {
                            setPriority(priority === 'Low' ? '' : 'Low');
                        }}>
                            <LowPriorityIcon style={{color: priority === 'Low' ? 'rgb(8,114,182)' : 'inherit'}}/>
                        </IconButton>
                        <div style={{width:'2%'}}></div>
                        <Typography variant='subtitle1'>{priority === '' ? 'Standard' : priority} priority</Typography>
                    </div>
                    <div style={{width:'fit-content', display:'flex', alignItems:'center', flexWrap:'wrap'}}>
                        {page > 1 && <IconButton aria-label="site-create-back" onClick={decrementPage}>
                            <ArrowBackIcon />
                        </IconButton>}

                        <div style={{flex:'10'}}></div>

                        <IconButton aria-label="site-create-next" onClick={incrementPage}>
                            {page < 2 ? <ArrowForwardIcon /> : page === 3 ? <DoneIcon /> : <GradingIcon/>}
                        </IconButton>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default AddTasksModal;